import { render, staticRenderFns } from "./TouchpointOverviewIconMagic.vue?vue&type=template&id=1ae374e3&scoped=true&functional=true&"
import script from "./TouchpointOverviewIconMagic.vue?vue&type=script&lang=js&"
export * from "./TouchpointOverviewIconMagic.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointOverviewIconMagic.vue?vue&type=style&index=0&id=1ae374e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "1ae374e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae374e3')) {
      api.createRecord('1ae374e3', component.options)
    } else {
      api.rerender('1ae374e3', component.options)
    }
    module.hot.accept("./TouchpointOverviewIconMagic.vue?vue&type=template&id=1ae374e3&scoped=true&functional=true&", function () {
      api.rerender('1ae374e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/TouchpointOverviewIconMagic.vue"
export default component.exports